import React from 'react'
import styled from '@emotion/styled'

import LoginCard from './components/LoginCard'

const LoginBackground = styled.div`
  width: 100vw;
  height: 100vh;
  background: #c9d6ff;
  background: linear-gradient(to right, #e2e2e2, #c9d6ff);

  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export default () => (
  <LoginBackground>
    <LoginCard />
  </LoginBackground>
)
